import React, { useEffect } from "react";
import '../css/sidebar.css';

export default function Sidebar({ onSambutanClick, onTentangClick }) {
    useEffect(() => {
        const hamBurger = document.querySelector(".toggle-btn");
        const sidebar = document.querySelector("#sidebar");

        const toggleSidebar = () => {
            sidebar.classList.toggle("expand");
        };

        hamBurger.addEventListener("click", toggleSidebar);

        return () => {
            hamBurger.removeEventListener("click", toggleSidebar);
        };
    }, []);

    return (
        <>
            <div class="wrapper">
                <aside id="sidebar">
                    <div class="d-flex">
                        <button class="toggle-btn mx-auto" type="button">
                            <img src="../../assets/icon.svg"></img>
                        </button>
                    </div>
                    <ul class="sidebar-nav">
                        <li class="sidebar-item">
                            <a href="#" class="sidebar-link" onClick={onSambutanClick}>
                            <img src="../../assets/sidebar/sambutan.png"></img>
                                <span>Sambutan</span>
                            </a>
                        </li>
                        <li class="sidebar-item">
                            <a href="#" class="sidebar-link" onClick={onTentangClick}>
                            <img src="../../assets/sidebar/tentang.png"/>
                                <span>Tentang SMA Lab UM</span>
                            </a>
                        </li>
                        <li class="sidebar-item">
                            <a href="#" class="sidebar-link">
                            <img src="../../assets/sidebar/struktur.png"/>
                                <span>Struktur Organigram</span>
                            </a>
                        </li>
                        <li class="sidebar-item">
                            <a href="#" class="sidebar-link">
                            <img src="../../assets/sidebar/guru.png"/>
                                <span>Guru & Karyawan</span>
                            </a>
                        </li>
                        <li class="sidebar-item">
                            <a href="#" class="sidebar-link">
                            <img src="../../assets/sidebar/statistik.png"/>
                                <span>Statistika</span>
                            </a>
                        </li>
                        <li class="sidebar-item">
                            <a href="#" class="sidebar-link">
                            <img src="../../assets/sidebar/logo.png"/>
                                <span>Logo</span>
                            </a>
                        </li>
                    </ul>
                </aside>
            </div>
        </>
    );
}
